module.exports = __webpack_public_path__ + "img/Mask Group@2x2.f1ec9cb5.png";